import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import {TooltipPlacement, TooltipWrapper} from 'ui-library/bs/Tooltip';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';

interface Props {
  buttonStyle: ButtonStyle;
  className?: string;
  disabled: boolean;
  size: ButtonSize;
  tooltipTitle?: string | null;
  onClick: () => void;
}

// eslint-disable-next-line react/prefer-stateless-function
export default class ExecuteButton extends React.Component<Props> {
  static propTypes = {
    buttonStyle: PropTypes.oneOf(Object.values(ButtonStyle)).isRequired,
    className: PropTypes.string,
    disabled: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
  };

  static defaultProps = {
    disabled: false,
    size: ButtonSize.SMALL,
  };

  render(): JSX.Element {
    return (
      <TooltipWrapper tooltipTitle={this.props.tooltipTitle} tooltipPlacement={TooltipPlacement.BOTTOM}>
        <div className={classNames('u-display-inline-block', this.props.className)}>
          <Button
            buttonStyle={this.props.buttonStyle}
            disabled={this.props.disabled}
            onClick={this.props.onClick}
            size={this.props.size}
            text="Execute"
            dataTestAttrs={{
              component: 'ExecuteButton',
              element: 'root',
            }}
          />
        </div>
      </TooltipWrapper>
    );
  }
}
